import { Fragment } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { hexToRgba } from "../../utils/funcs/common";
import { IInputSearchableDropdown } from "../../interfaces/app_types";

const colorStyles = {
  control: (styles, { isDisabled, isFocused }) => ({
    ...styles,
    backgroundColor: isDisabled ? "hsl(0, 0%, 95%)" : "white",
    borderColor: isFocused ? "#5f3a21" : "#dedfdf",
    boxShadow: isFocused ? "0 0 0 2px #3a281c20" : "none",
    ":hover": { borderColor: "#5f3a21" },
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = data.color;
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? hexToRgba(data.color, 0.3)
        : isFocused
        ? hexToRgba(color, 0.3)
        : undefined,
      color: isDisabled ? "#62666c" : "#292b2e",
      cursor: isDisabled ? "not-allowed" : "default",

      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled
          ? isSelected
            ? hexToRgba(color, 0.2)
            : hexToRgba(color, 0.3)
          : undefined,
      },
    };
  },
  multiValue: (styles, { data }) => {
    const color = data.color;
    return {
      ...styles,
      backgroundColor: hexToRgba(color, 0.1),
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#292b2e",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#292b2e",
    ":hover": {
      backgroundColor: "#fbe9df",
      color: "#8a3510",
    },
  }),
};
const InputSearchableDropdown = ({
  options,
  control,
  isMulti = false,
  isAsync = false,
  selectedValue,
  name,
  errorMessage,
  handleSelectChange,
  disabled = false,
  isColor = false,
  label = "",
}: IInputSearchableDropdown) => {
  return (
    <Fragment>
      <label htmlFor="" className=" d-flex salary-input-text col-2 ">
        Select {label === "" ? name : label}:
      </label>
      <Controller
        control={control}
        name={name}
        defaultValue={selectedValue}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, onBlur, value } }) =>
          isAsync ? (
            <Select
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "#5f3a21",
                  primary25: "#fff5e8",
                  primary50: "#f4dfca",
                },
              })}
              isMulti={isMulti}
              options={options}
              styles={isColor ? colorStyles : undefined}
              value={value}
              className={isMulti ? "basic-multi-select" : "basic-select"}
              isLoading={true}
              isDisabled={disabled}
              isClearable={true}
              classNamePrefix="select"
              onChange={(selectedOption) => {
                onChange(selectedOption);
                handleSelectChange?.(selectedOption);
              }}
              onBlur={onBlur}
            />
          ) : (
            <Select
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "#5f3a21",
                  primary25: "#fff5e8",
                  primary50: "#f4dfca",
                },
              })}
              isMulti={isMulti}
              options={options}
              value={value}
              isDisabled={disabled}
              styles={isColor ? colorStyles : undefined}
              className={isMulti ? "basic-multi-select" : "basic-select"}
              isClearable={true}
              onChange={(selectedOption) => {
                onChange(selectedOption);
                handleSelectChange?.(selectedOption);
              }}
              classNamePrefix="select"
              onBlur={onBlur}
            />
          )
        }
      />
      <div className="text-danger">{errorMessage}</div>
    </Fragment>
  );
};

export default InputSearchableDropdown;
